<template>
  <!--签到抽奖页面-->
  <tk-container
    :status="status"
    :probeType="3"
    hide-status-bar
    class="check-page-theme"
    :style="{ background: bgColor, backgroundImage: `url(${bgSrc}) !important` }"
    @refresh="getInit"
    @scroll="watchScroll"
  >
    <!--头部-->
    <gradient-header slot="header" :z-index="zIndex" :is-show-back="true" :is-header-color="isHeaderColor" :back-style="false" :icon-name="'fanhui'">
      <div slot="center-menu" :style="{ color: isHeaderColor ? '#000000' : '#fff' + '!important', zIndex: zIndex }">我的幸运星</div>
      <div
        slot="right-menu"
        class="font-14"
        :style="{ color: isHeaderColor ? '#000000' : '#fff' + '!important', zIndex: zIndex }"
        @click="$push('/signLottery/luckyStarRecords')"
      >
        明细
      </div>
    </gradient-header>
    <!--背景图渲染-->
    <div class="check-page-bg">
      <!--幸运星数量显示及规则-->
      <tk-flex center column class="p-x-12 check-page-bg-star">
        <tk-flex middle center class="m-t-10 font-14 page-bg-star-space">
          当前 <span class="font-32 font-bold">{{' ' + luckStarSum + ' '}}</span>颗
          <tk-image :replacement="false" :src="starImage" width="25" height="25"></tk-image>
        </tk-flex>
        <div class="m-t-10 font-12">累计满1500颗抽奖1次</div>
        <tk-flex
          right middle
          class="full-width m-t-10 font-12"
          @click.native="isShowRule = true"
        >
          活动规则 <tk-icon size="11" class="m-l-5" color="rgba(245, 245, 245, 1)">rightarrow</tk-icon>
        </tk-flex>
      </tk-flex>
      <!--签到背景-->
      <div class="m-x-12 m-t-16">
        <div
          class="check-page-bg-check p-12"
          :style="`background-image: url(${decorationSrc}) !important`"
        >
          <tk-flex middle class="full-width">
            <div class="tk-grid-1"></div>
            <div class="tk-grid-7" style="white-space: nowrap;">
              <div class="font-14 m-t-15">
                今日签到可得 <span class="font-bold" style="color: #FB952F;">{{checkStarSum}}</span> 颗幸运星
              </div>
              <div class="caption m-t-5">会员级别越高 签到可得越多</div>
            </div>
            <div class="tk-grid-4 text-right">
              <tkui-button
                @click="checkIn"
                :disabled="checkDisabled"
                :style="{backGround: checkColor}"
                class="m-t-12 small primary raised rounded check-page-bg-check-btn"
              >
                {{checkText}}
              </tkui-button>
            </div>
          </tk-flex>
        </div>
      </div>
      <!--活动规则弹框-->
      <tk-cover
        :show.sync="isShowRule"
        center
        transition
      >
        <div
          class="rule-cover"
        >
          <div class="cover-bg">
            <!--关闭规则按钮-->
            <div class="cover-close" @click="isShowRule = false">
              <tk-icon color="#fff" size="24">delete</tk-icon>
            </div>
            <div class="cover-scroll">
              <!--规则渲染-->
              <div class="scroll-title">活动规则</div>
              <!--规则列表-->
              <div class="m-t-8 scroll-list-color">
                一、适用对象
              </div>
              <div class="m-t-8 scroll-list-color">一级会员</div>
              <div class="m-t-8 scroll-list-color">
                二、活动介绍
              </div>
              <div class="m-t-8 scroll-list-color">1. 每日可签到1次，每次最少可得50颗幸运星</div>
              <div class="m-t-8 scroll-list-color">2. 会员级别越高，签到可得越多，最高每次签到可得100颗幸运星</div>
              <div class="m-t-8 scroll-list-color">3. 累计得到1500颗幸运星，可以抽奖1次</div>
              <div class="m-t-8 scroll-list-color">4. 100%中奖，奖品随机，不定期更换</div>
              <div class="m-t-8 scroll-list-color">5. 幸运星可以在“生日祝福”中，转让给过生日的朋友</div>
              <div class="m-t-8 scroll-list-color">三、其他说明</div>
              <div class="m-t-8 scroll-list-color">本规则若有变更，以平台通知为准</div>
              <div class="m-t-8 scroll-list-color">声明：抽奖奖品由威选商城提供，Apple不是赞助商，也没有以任何形式参与活动。</div>
            </div>
          </div>
        </div>
      </tk-cover>
      <!--转盘抽奖-->
      <div class="wheel-warp" :style="{
        backgroundImage: `url(${drawWheel})`,
        backgroundSize: '100% 100%'}">
        <div :class="rotate ? 'wheel-rotate' : ''" :style="{transform: `rotate(${baseRote}deg)`, fontSize: '0', transformOrigin: 'center center'}">
          <canvas id="wheel-canvas" width="516" height="516"></canvas>
        </div>
        <img :src="drawBtn" alt="" :class="{'closedCss': flag === false}" id="wheel-tupBtn" @click="beginRotate">
      </div>
      <!--剩余抽奖次数-->
      <div class="font-14 wheel-count">
        剩余<span class="count-color">{{lotteryCount}}</span>次抽奖机会
      </div>
      <!--我的奖品按钮-->
      <tk-flex center class="m-y-16">
        <tkui-button class="wheel-prize" @click="$push('/signLottery/drawRecords')">我的奖品</tkui-button>
      </tk-flex>
      <div style="height: 40px;"></div>
      <!--抽奖成功弹框-->
      <tk-cover
        :show.sync="isShowSuccess"
        center
        :hideOnClick="false"
        transition
      >
        <tk-flex center middle class="p-15 full-width">
          <div style="position: relative">
            <tk-image :src="successImage" :replacement="false" width="301" height="273"></tk-image>
            <div class="tips-closed" @click="isShowSuccess = false">
              <tk-icon color="#fff" size="28">delete</tk-icon>
            </div>
          </div>
          <tk-flex center middle column class="success-tips">
            <div class="font-24 font-24 font-bold class-card-wrap tips-text">恭喜您获得</div>
            <div class="font-18 m-t-10 font-bold" v-if="lotteryPrize && lotteryPrize.prize">{{lotteryPrize.prize + '一个'}}</div>
          </tk-flex>
        </tk-flex>
      </tk-cover>
    </div>
  </tk-container>
</template>

<script>
import drawWheel from '@/assets/img/draw_wheel.png' // 转盘背景图片
import drawBtn from '@/assets/img/draw_btn.png' // 抽奖按钮图片
import successImage from '@/assets/img/success.png' // 抽奖成功图片
const checkColor = 'linear-gradient(90deg,rgba(253,68,84,1),rgba(255,106,72,1)) !important' // 签到颜色
const starImage = 'https://s3.moke.cloud/dianpei/4da58e0d-2bdb-4ce8-a13d-53e7fe840ac6.png' // 规则星星图片
export default {
  data () {
    return {
      status: 'loading', // 页面状态
      zIndex: 100, // 头部层
      isHeaderColor: false, // 判断头部颜色切换
      checkDisabled: false, // 签到按钮状态
      themeBackground: null, // 主题背景图片
      starImage: starImage, // 星星图片
      successImage: successImage, // 抽奖成功图片
      isShowRule: false, // 是否展示规则
      isShowSuccess: false, // 抽奖成功弹框
      checkText: '签到', // 签到描述
      checkColor: checkColor, // 签到按钮颜色
      checkInRecords: null, // 签到记录
      wallet: null, // 钱包数据
      drawWheel, // 转盘底部图片
      drawBtn, // 转盘按钮图片
      flag: true, // 转盘点击校验
      prizeList: [], // 奖品列表
      rotate: false,
      baseRote: 0, // 旋转角度
      // ----- ① 清空页面元素，用于逐帧动画
      lotteryPrize: null // 中奖奖品
    }
  },
  computed: {
    // 背景图src
    bgSrc () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.image)) { return '' }
      return this.themeBackground.image
    },
    // 背景颜色
    bgColor () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.bgColor)) { return '' }
      return this.themeBackground.bgColor
    },
    // 装饰图src
    decorationSrc () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.decoration)) { return '' }
      return this.themeBackground.decoration
    },
    // 幸运星数量
    luckStarSum () {
      if (!this.wallet) { return 0 }
      return this.wallet.luckyStar
    },
    // 签到可得幸运星数量注册会员与铜牌会员赠送50，银牌会员赠送60，金牌会员赠送75，钻石会员赠送100
    checkStarSum () {
      if (!this.userInfo.accountCategory) { return 0 }
      if (this.userInfo.accountCategory !== 'countyAccount') { return 0 }
      if (this.levelName === 'registeredMember' || this.levelName === 'bronzeMember') { return 50 }
      if (this.levelName === 'silverMembers') { return 60 }
      if (this.levelName === 'goldMembers') { return 75 }
      if (this.levelName === 'diamondMembers') { return 100 }
      return 0
    },
    // 抽奖次数
    lotteryCount () {
      if (this.luckStarSum < 1500) { return 0 }
      return Math.floor(this.luckStarSum / 1500)
    }
  },
  activated () {
    this.setStatusBar('light')
    if (this.isHeaderColor) {
      this.setStatusBar('dark')
    }
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark')
    next(true)
  },
  methods: {
    /**
     * 页面初始化
     * @date: 2020/4/8
     */
    async getInit () {
      try {
        await this.getThemeBackground() // 获取主题图片
        await this.updatedUserInfo() // 更新用户信息
        await this.getWallet() // 获取用户钱包
        await this.getCheckInRecords() // 判断签到记录
        await this.initPrizeList() // 请求转盘数据
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      this.setStatusBar(this.isHeaderColor ? 'dark' : 'light')
      this.$forceUpdate()
    },
    /**
     * 获取主题图片
     * @date: 2020/4/8
     */
    async getThemeBackground () {
      let themeBackground = await this.$tkParse.getList('/classes/themeBackground', {
        params: {
          limit: 1,
          order: '-createdAt',
          where: {
            position: 'checkInDraw'
          }
        }
      })
      if (themeBackground.length) { this.themeBackground = themeBackground[0] } else {
        this.themeBackground = null
      }
    },
    /**
    * 更新用户信息
    * @date: 2020/4/11
    */
    async updatedUserInfo () {
      let user = this.$tkParse.getData(`/classes/_User/${this.userInfo.objectId}`)
      await this.$store.dispatch('updateUserMsg', {
        membershipLevel: user.membershipLevel,
        accountCategory: user.accountCategory
      })
    },
    /**
    * 获取用户钱包
    * @date: 2020/4/11
    */
    async getWallet () {
      let wallet = await this.$tkParse.getList('/classes/wallet', {
        params: {
          limit: 1,
          where: {
            user: this.userInfo.objectId
          }
        }
      })
      if (wallet.length) { this.wallet = wallet[0] } else { this.wallet = null }
    },
    /**
    * 判断签到记录
    * @date: 2020/4/11
    */
    async getCheckInRecords () {
      let isoStartDate = this.$tkDate().startOf('day').toISOString()
      let isoEndDate = this.$tkDate().endOf('day').toISOString()
      let checkInRecords = await this.$tkParse.getList(`/classes/checkInRecords`, {
        params: {
          limit: 1,
          where: {
            user: this.userInfo.objectId,
            checkInTime: {
              $gte: {
                '__type': 'Date',
                'iso': isoStartDate
              },
              $lte: {
                '__type': 'Date',
                'iso': isoEndDate
              }
            }
          }
        }
      })
      if (checkInRecords.length) {
        this.checkInRecords = checkInRecords[0]
        this.checkDisabled = true
        this.checkText = '已签到'
        this.checkColor = 'rgba(0, 0, 0, 0.1)'
      } else {
        this.checkInRecords = null
      }
    },
    /**
    * 签到
    * @date: 2020/4/11
    */
    async checkIn () {
      try {
        this.status = 'waiting'
        // 判断是否已经签到
        this.checkDisabled = true
        this.checkText = '已签到'
        this.checkColor = 'rgba(0, 0, 0, 0.1)'
        await this.getCheckInRecords()
        if (this.checkInRecords) {
          this.status = false
          return this.$tkGlobal.toast.add('您已经签过到了')
        }
        // 获取服务器时间 即现在时间
        let nowTime = await this.$tkParse.getData(`https://api.mokekeji.com/time`)
        // 准备发送云代码数据
        let checkObj = {
          userId: this.userInfo.objectId, // 用户id
          checkInTime: nowTime, // 签到时间
          checkStarSum: this.checkStarSum // 送出的星星数
        }
        await this.$cloudAjax.post('/check/$check', checkObj).catch(e => {
          this.status = false
          this.checkDisabled = false
          throw this.$tkGlobal.toast.add(e.data ? e.data : '签到失败')
        })
        await this.getWallet() // 获取用户钱包
        await this.getCheckInRecords() // 判断签到记录
        this.$tkGlobal.toast.add('签到成功')
        this.status = false
      } catch (e) {
        this.status = false
        this.$tkGlobal.toast.add('签到失败')
      }
    },
    /**
    * 获取奖品列表
    * @date: 2020/4/17
    */
    async initPrizeList () {
      // 这里可以发起请求，从服务端获取奖品列表
      let prizeList = await this.$tkParse.getList('/classes/turntableSettings', {
        params: {
          order: 'createdAt',
          limit: 8
        }
      })
      prizeList.reduce((value, item) => {
        item.min = value
        item.max = value + item.probability
        return value + item.probability
      }, 0)
      this.lastIndex = prizeList.length
      this.prizeList = prizeList
      this.baseRote = 180 / (prizeList.length)
      await this.drawCanvas()
      setTimeout(() => {
        this.rotate = true
      }, 500)
    },
    /**
    * 绘制文字
    * @date: 2020/4/20
    */
    addText (text, ctx, i) {
      // ----绘制奖品开始----
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      const basex = 20 * Math.sin(((360 / this.prizeList.length) / 180) * Math.PI)
      const basey = 20 * Math.cos(((360 / this.prizeList.length) / 180) * Math.PI)
      const baseL = Math.sqrt(Math.pow(basex, 2) + Math.pow(basey, 2))
      ctx.rotate(((360 / this.prizeList.length) * Math.PI) / 180)
      ctx.font = 'bold 22px Microsoft YaHei'
      if (i % 2 === 0) ctx.fillStyle = 'rgba(244, 83, 66, 1)'
      else {
        ctx.fillStyle = '#fff'
      }
      // ctx.rotate(Math.PI / 180 * 90)
      /** 下面代码根据奖品类型、奖品名称长度渲染不同效果，如字体、颜色、图片效果。(具体根据实际情况改变) **/
      let baseSize = 26
      let texts = text
      if (text.length > 5) { // 奖品名称长度超过一定范围
        texts = text.substring(0, 5) + '.'
      }
      // 在画布上绘制填色的文本。文本的默认颜色是黑色
      if (i % 2 === 0) ctx.fillStyle = 'rgba(244, 83, 66, 1)'
      else {
        ctx.fillStyle = '#fff'
      }
      for (let s = 0; s < texts.length; s++) {
        ctx.save()
        const ratio = (baseL - (baseSize * s)) / baseL
        const nextx = basex * ratio
        const nexty = basey * ratio
        ctx.translate(nextx, nexty)
        ctx.rotate((-(360 / this.prizeList.length) * Math.PI) / 180)
        ctx.fillText(texts[texts.length - s - 1], 0, 0)
        ctx.restore()
      }
    },
    /**
     * 绘制转盘
     * @date: 2020/4/20
     */
    async drawCanvas () {
      let canvas = document.getElementById('wheel-canvas')
      let ctx = canvas.getContext('2d')
      let arc = Math.PI / (this.prizeList.length / 2)
      ctx.clearRect(0, 0, 516, 516)
      ctx.strokeStyle = '#FFA800'
      ctx.font = 'bold 22px Microsoft YaHei'
      for (let i = 0; i < this.prizeList.length; i++) {
        let angle = -(Math.PI / 2) + i * arc
        if (i % 2 === 0) ctx.fillStyle = '#FBDB00'
        else {
          ctx.fillStyle = '#FFA800'
        }
        ctx.beginPath()
        ctx.arc(258, 258, 258, angle, angle + arc, false)
        ctx.arc(258, 258, 58, angle + arc, angle, true)
        ctx.stroke()
        ctx.fill()
        // --- 绘制文字
        ctx.save()
        ctx.fillStyle = '#E83800'
        let text = this.prizeList[i].prize
        ctx.translate(258 + Math.cos(angle + arc / 2) * 165, 258 + Math.sin(angle + arc / 2) * 165)
        ctx.rotate(angle + arc / 2 + Math.PI / 2)
        // 添加文字
        this.addText(text, ctx, i)
        ctx.restore()
      }
    },
    /**
    * 点击旋转
    * @date: 2020/4/20
    */
    async rotateWheel () {
      let number = Math.floor((Math.random() * 100))
      let num = null
      this.prizeList.forEach((item, index) => {
        if (item.min <= number && number < item.max) {
          num = index
          return true
        }
      })
      if (!this.prizeList[num]) {
        num = this.prizeList.length
      }
      // 计算角度
      this.baseRote =
        this.baseRote -
        this.baseRote % 360 + 6 * 360 +
        (360 - 360 / this.prizeList.length * num) - (180 / this.prizeList.length)
      // 获取奖品添加奖品记录
      await this.getValue(num)
    },
    /**
    * 点击抽奖
    * @date: 2020/4/17
    */
    async beginRotate () {
      if (!this.flag) return
      this.flag = false
      // 添加次数校验
      if (this.lotteryCount === 0) {
        this.flag = true
        return this.$tkGlobal.toast.add('您没有更多抽奖次数了')
      }
      // 消耗幸运星
      await this.$cloudAjax.post('/check/$consumeStar', {
        userId: this.userInfo.objectId
      }).catch(e => {
        this.flag = true
        throw this.$tkGlobal.toast.add(e.data ? e.data : '抽奖失败')
      })
      // 更新钱包信息
      await this.getWallet() // 获取用户钱包
      await this.rotateWheel()
    },
    /**
    * 添加抽奖记录
    * @date: 2020/4/20
    */
    async addPrizeRecords () {
      if (!this.lotteryPrize) { return }
      await this.$tkParse.post('/classes/drawRecords', {
        user: this.userInfo.objectId,
        prize: this.lotteryPrize.prize,
        isIssue: false
      })
    },
    /**
     * 旋转结束，获取值
     * @date: 2020/4/20
     */
    async getValue (index) {
      this.lotteryPrize = this.prizeList[index]
      await this.addPrizeRecords()
      await this.$tkHelper.sleep(3000)
      this.flag = true
      this.isShowSuccess = true
    }
  }
}
</script>

<style scoped lang="scss">
  .check-page-theme {
    width: 100%;
    min-height: 200px;
    background-size: 100% 200px !important;
    background-repeat: no-repeat !important;
    background-attachment: fixed !important;
  }
  /*背景图样式*/
  .check-page-bg {
    padding-top: 60px;
    .check-page-bg-star {
      color: #fff;
      .page-bg-star-space {
        margin-left: 10px;
        letter-spacing: 3px;
      }
    }
    /*签到样式*/
    .check-page-bg-check {
      width: 100%;
      min-height: 100px;
      background-repeat:  no-repeat;
      background-size: cover;
      overflow: hidden;
      border-radius: 5px;
      padding: 15px;
      .check-page-bg-check-btn {
        min-width: 66px;
        height: 29px;
        border-radius: 15px;
      }
    }
  }
  /*为你推荐背景*/
  .check-page-infinite-bg {
    background-color: rgba(248, 248, 248, 1);
  }
  /*规则弹框*/
  .rule-cover {
    width: 80%;
    height: 424px;
    border-radius: 5px;
    background: rgba(252, 247, 240, 1);
    .cover-bg {
      position: relative;
    }
    .cover-close {
      position: absolute;
      bottom: -73px;
      z-index: 1;
      right: 46%;
    }
    .cover-scroll {
      overflow-y: scroll;
      overflow-x: hidden;
      height: 390px;
      padding: 8px 25px 40px 25px;
      .scroll-title {
        font-size: 16px !important;
        text-align: center;
        color: rgba(220, 144, 89, 1);
      }
      .scroll-list-color {
        font-size: 13px;
        color: rgba(71, 72, 76, 1);
      }
    }
  }
  /*转盘样式*/
  .wheel-warp {
    width: 100%;
    position: relative;
    padding: 12.5%;
    background-repeat:  no-repeat;
    margin: auto;
  }
  #wheel-canvas {
    width: 100%;
  }
  #wheel-tupBtn {
    position: absolute;
    top: 49%;
    left: 50%;
    z-index: 2;
    width: 20.5%;
    height: 23.5%;
    transform: translate3d(-50%, -50%, 0);
  }
  .wheel-rotate {
    transition: all ease 6s;
  }
  /*剩余次数样式*/
  .wheel-count {
    color: #C76403;
    text-align: center;
    .count-color {
      font-weight: bold;
      color: #F6343C;
      font-size: 16px;
    }
  }
  /*我的奖品按钮样式*/
  .wheel-prize {
    min-width: 230px;
    height: 44px;
    background: linear-gradient(90deg,rgba(253,68,84,1),rgba(255,106,72,1));
    border-radius: 44px;
    color: #fff;
  }
  /*抽奖成功样式*/
  .tips-closed {
    position: absolute;
    top: 10%;
    right: 10%;
    z-index: 1;
  }
  .success-tips {
    width: 80%;
    height: 20%;
    position: absolute;
    left: 10%;
    background-size: 100% auto;
    background-repeat: no-repeat;
    color: #D25605;
    text-shadow:0 2px 10px rgba(210, 86, 5, 0.33);
    .tips-text {
      width: 50%;
      margin-top: 10%;
      text-align: center;
    }
  }
</style>
